import { useSelector } from 'react-redux';
import { yextSelector } from '../../utils/selectors/globalsSelectors';

export function useYext(): string | null {
  return useSelector(yextSelector);
}
